import { fields } from "@monorepo/utils/src/variables/projectsData/syncLogOikView/fields";

export const currentFilters = (): Record<string, unknown> => ({
  [fields.OIK_NAME]: "",
  [fields.OIK_ID]: "",
  [fields.STATUS]: [],
  [fields.DATE_TO]: "",
  [fields.DATE_FROM]: "",
});
